import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  CompoundsListing,
  CompoundsListModal,
  COMPOUNDS_LIST_PAGE_LIMIT,
  CompoundsListingQueryParameters,
} from "./type";

const initialState: CompoundsListModal = {
  compoundsListing: {
    data: [],
    total: 0,
    limit: 0,
    pageNo: 0,
    nextHit: 0,
    totalPage: 0,
  },
  compoundsListingQueryParameters: {
    pageNo: 1,
    limit: COMPOUNDS_LIST_PAGE_LIMIT,
    searchKey: "",
    type: "cannabinoids",
  },
  hasMore: false,
};

const compoundsListSlice = createSlice({
  name: "compoundsListSlice",
  initialState,
  reducers: {
    setCompoundsListingData: (
      state: CompoundsListModal,
      action: PayloadAction<CompoundsListing>,
    ) => {
      const newPayload = action.payload;

      if (newPayload.pageNo > 1) {
        state.compoundsListing = {
          ...newPayload,
          data: [...state.compoundsListing.data, ...newPayload.data],
        };
      } else {
        state.compoundsListing = newPayload;
      }

      state.hasMore = newPayload.totalPage > newPayload.pageNo;
    },

    setCompoundsListingQueryParameters: (
      state: CompoundsListModal,
      action: PayloadAction<Partial<CompoundsListingQueryParameters>>,
    ) => {
      state.compoundsListingQueryParameters = {
        ...state.compoundsListingQueryParameters,
        ...action.payload,
      };
    },

    setResetCompoundsListing: (state: CompoundsListModal) => {
      state.compoundsListing = {
        data: [],
        total: 0,
        limit: state.compoundsListingQueryParameters.limit,
        pageNo: 0,
        nextHit: 0,
        totalPage: 0,
      };
      state.compoundsListingQueryParameters.pageNo = 1;
      state.hasMore = false;
    },

    clearCompoundsListState: () => initialState,
  },
});

export const {
  setCompoundsListingData,
  setCompoundsListingQueryParameters,
  setResetCompoundsListing,
  clearCompoundsListState,
} = compoundsListSlice.actions;

export default compoundsListSlice.reducer;
